require("bootstrap");
import "../stylesheets/information.scss";
import 'select2'
import 'select2/dist/css/select2.css'

document.addEventListener("DOMContentLoaded", () => {
  $(".campaign-selector").click(function(){
    const kind = this.getAttribute("data-kind");
    $(`.card`).hide();
    $(`.${kind}`).show();
    ['fundraising', 'cause', 'raffle'].forEach(function(element){
      $(`.campaign-selector.${element}-text-color`).addClass(`${element}-gradient-background`);
      $(`.campaign-selector.${element}-text-color`).removeClass(`${element}-text-color`);
    });
    this.classList.remove(`${kind}-gradient-background`);
    this.classList.add(`${kind}-text-color`);
  });
  $('.foundations').select2({
    placeholder: 'Seleccione una o varias fundaciones para filtrar',
    allowClear: true
  });
});